import "./Navbar.css";
import { useState, useEffect } from "react";

const Navbar = () => {
 const [toggleShowNav, setToggleShowNav] = useState(false);

 const toggleNavDisplay = () => {
  setToggleShowNav((e) => !e);
  console.log("clicked");
 };

 useEffect(() => {
  document
   .querySelector(".sidebar .smooth-scroll")
   .addEventListener("click", toggleNavDisplay);
  document
   .querySelector(".mobile-menu")
   .addEventListener("click", toggleNavDisplay);
 }, []);

 return (
  <>
   <div className={toggleShowNav ? "sidebar show" : "sidebar"}>
    <a className="smooth-scroll" href="http://a.com">
     Home
    </a>
    <a className="smooth-scroll" href="http://a.com">
     Invest
    </a>
    <a className="smooth-scroll" href="http://a.com">
     Contact Us
    </a>
    <a className="smooth-scroll" href="http://a.com">
     About
    </a>
   </div>
   <nav className="nav-container navbar">
    <div className="wrapper">
     <div className="brand-logo">
      <h1
       className="semi-bold"
       style={{ color: "#ed1c24", fontSize: "1.4rem" }}
      >
       Orange
      </h1>
     </div>
     <ul className="desktop nav-links">
      <li>
       <a href="https://a.com" className="smooth-scroll">
        Home
       </a>
      </li>
      <li>
       <a href="https://a.com" className="smooth-scroll">
        Invest
       </a>
      </li>
      <li>
       <a href="https://a.com" className="smooth-scroll">
        Contact Us
       </a>
      </li>
      <li>
       <a href="https://a.com" className="smooth-scroll">
        About
       </a>
      </li>
     </ul>

     <div className="desktop nav-cta-buttons">
      <button className="nav-btn">Login</button>
      <button className="nav-btn">Register</button>
     </div>

     <div className="mobile-menu">
      {!toggleShowNav && <i class="fa fa-bars" aria-hidden="true"></i>}
      {toggleShowNav && (
       <i
        class="fa fa-times"
        style={{ color: "#ed1c24" }}
        aria-hidden="true"
       ></i>
      )}
     </div>
    </div>
   </nav>
  </>
 );
};

export default Navbar;
